import React from 'react';
import PropTypes from 'prop-types';
import { ButtonIcon } from '../shared/components/ButtonIcon';
import { BadgeLabel } from '../shared/components/BadgeLabel';
import Badge from '../shared/components/Badge';

export default class AttachmentList extends React.Component {

    render() {
        const {
            documents,
            style,
        } = this.props;

        return (
            <div className="attachment-list" style={style}>
                {
                    Object.values(documents).map(this.renderDoc)
                }
            </div>
        );
    }

    renderDoc = (doc) => {
        const {
            files,
            onRemoveDocument,
        } = this.props;

        return (
            <div
                key={doc.id}
                className="al-item"
            >
                <div className="al-doc">
                    {
                        onRemoveDocument && (
                            <ButtonIcon
                                icon={'remove'}
                                className="form-list-button"
                                onClick={() => onRemoveDocument(doc)}
                            />
                        )
                    }
                    <div className="al-doc-name">
                        {doc.name}
                    </div>
                    <div className="al-extensions">
                        {
                            doc.extensions.map(ext => <BadgeLabel key={ext} label={ext}/>)
                        }
                    </div>
                </div>
                {
                    files && (
                        <div className="al-files">
                            {
                                Object.values(files).map((file) => this.renderFile(file, doc.revisions))
                            }
                        </div>
                    )
                }
            </div>
        );
    };

    renderFile = (file, revisions) => {
        const revision = revisions[file.uuid];
        const hasBeenUploaded = !revision;

        return (
            <div
                key={file.uuid}
                className="al-file"
            >
                <Badge color={hasBeenUploaded ? 'green' : 'red'}/>
                <div>{file.name}</div>
                <div className="al-file-error">{revision}</div>
            </div>
        );
    };

}

AttachmentList.propTypes = {
    files: PropTypes.object,
    documents: PropTypes.object.isRequired,
    onRemoveDocument: PropTypes.func,
};

AttachmentList.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/attachment/AttachmentList.jsx